import React from 'react';
import styled from '@emotion/styled';

import HeadDesktop from './HeadDesktop';
import FilmrPromoScreen from '@components/Filmr/FilmrPromoScreen';
import useDeviceDetect from '@hooks/useDeviceDetect';

function Head({ workflow }) {
  const { isMobile, deviceOS } = useDeviceDetect();
  const onClickDownloadLink = () => {
    api.sendAmplitudeEvent('Download app click', {
      'Operating System': deviceOS,
    });
  };

  return (
    <HeadSection className="content-section">
      <div className="banner-section">
        <HeadDesktop workflow={workflow} />
        <div className="video-wrapper">
          <div className="filmr-promo">
            <FilmrPromoScreen
              filmrLinks={{
                iOS: 'https://filmrapp.onelink.me/9iEj/8d9711a1',
                android: 'https://filmrapp.onelink.me/AezS/61d0774b',
              }}
              showFirstScreen={false}
              deviceOS={deviceOS}
              onClickDownloadLink={onClickDownloadLink}
              isSticky
            />
          </div>
          <div className="progressive-image" id="home-video">
            <video
              playsInline
              preload="auto"
              className="video-player desktop"
              poster="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/v3_video_montage-small.jpg"
              id="main-video"
              autoPlay
              muted
              loop
            >
              <source
                src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/homepage-desk-video.mp4"
                type="video/mp4"
              />
            </video>
            {/* <video
              playsInline
              preload="auto"
              className="video-player mobile"
              poster="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/home-mobile-poster.jpg"
              id="main-video-mobile"
              muted
              autoPlay
              loop
            >
              <source
                src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/homepage-mob-video.mp4"
                type="video/mp4"
              />
            </video> */}
          </div>
          <div className="home-brands desktop flex justify-end items-center my-4">
            <div className="brand-wrapper">
              <h4 className="partners-title text-xl text-brandPrimary">
                Our customers:
              </h4>
            </div>
            <div className="brand-wrapper">
              <picture>
                <source
                  type="image/webp"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/at_t.webp"
                />
                <source
                  type="image/png"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/at_t_tiny.png"
                />
                <img
                  alt="Out Customers AT"
                  loading="lazy"
                  className="w-24 mx-2"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/at_t_tiny.png"
                />
              </picture>
            </div>
            <div className="brand-wrapper">
              <picture>
                <source
                  type="image/webp"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/microsoft.webp"
                />
                <source
                  type="image/png"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/microsoft_tiny.png"
                />
                <img
                  alt="Out Customers Microsoft"
                  loading="lazy"
                  className="w-24 mx-2"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/microsoft_tiny.png"
                />
              </picture>
            </div>
            <div className="brand-wrapper">
              <picture>
                <source
                  type="image/webp"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/aspen.webp"
                />
                <source
                  type="image/png"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/aspen_tiny.png"
                />
                <img
                  alt="Out Customers ASPEN"
                  loading="lazy"
                  className="w-24 mx-2"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/aspen_tiny.png"
                />
              </picture>
            </div>
            <div className="brand-wrapper">
              <picture>
                <source
                  type="image/webp"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/reuters.webp"
                />
                <source
                  type="image/png"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/reuters.png"
                />
                <img
                  alt="Out Customers Reuters"
                  loading="lazy"
                  className="w-24 mx-2"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/reuters.png"
                />
              </picture>
            </div>
            <div className="brand-wrapper">
              <picture>
                <source
                  type="image/webp"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/zoho.webp"
                />
                <source
                  type="image/png"
                  srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/zoho.png"
                />
                <img
                  alt="Out Customers ZOHO"
                  loading="lazy"
                  className="w-24 mx-2"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/zoho.png"
                />
              </picture>
            </div>
          </div>
          <div className="home-brands mobile flex flex-col justify-center items-center my-4">
            <div className="brand-wrapper">
              <h4 className="partners-title text-lg py-4 text-brandPrimary">
                3M+ premium media from
              </h4>
            </div>
            <div className="flex flex-wrap items-center justify-center">
              <div className="brand-wrapper w-2/5 p-4">
                <picture>
                  <img
                    alt="Shutterstock"
                    loading="lazy"
                    src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/shutterstock.png"
                  />
                </picture>
              </div>
              <div className="brand-wrapper w-2/5 p-4">
                <picture>
                  <img
                    alt="Pixabay"
                    loading="lazy"
                    src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/pixabay.png"
                  />
                </picture>
              </div>
              <div className="brand-wrapper w-2/5 p-4">
                <picture>
                  <img
                    alt="Unsplash"
                    loading="lazy"
                    src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/unsplash.png"
                  />
                </picture>
              </div>
              <div className="brand-wrapper w-2/5 p-4">
                <picture>
                  <img
                    alt="Storyblocks"
                    loading="lazy"
                    src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/storyblocks.png"
                  />
                </picture>
              </div>
            </div>
          </div>
          <div className="overlay-parent desktop">
            <div className="overlay-content">
              <div className="text-content">
                <p>Seemingly</p>
                <p>tough.</p>
                <p>Surprisingly</p>
                <p>easy.</p>
              </div>
              <button
                className="hidden-started-btn"
                onClick={() =>
                  workflow('/workflow/marketing-templates/', 'center')
                }
                id="get-started"
                data-toggle="modal"
                data-target="#authModal"
              >
                Get Started - IT&apos;S FREE
              </button>
            </div>
            <img
              alt="Overlay Cursor"
              className="overlay-cursor"
              loading="lazy"
              src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/cursor-icon-2.png"
            />
            <div className="boundings-wrapper">
              <div className="bound-container">
                <span className="line top" />
                <span className="line right" />
                <span className="line bottom" />
                <span className="line left" />
                <span className="square top" />
                <span className="square right" />
                <span className="square bottom" />
                <span className="square left" />
              </div>
            </div>
          </div>
          {/* <div className="overlay-parent mobile">
            <div className="title mb-4">
              <p>Make scroll stopping videos in mins</p>
            </div>
            <div className="sub-title mb-4">
              <p>
                Over 4000+ designer templates for all your social media needs.
              </p>
            </div>
            <div className="cta">
              <button
                type="button"
                onClick={workflow}
                data-toggle="modal"
                className="mb-4"
                data-target="#authModal"
              >
                Get started
              </button>
            </div>
            <div className="cta-sub-title">
              <p>No credit card required</p>
            </div>
          </div> */}
        </div>
      </div>
    </HeadSection>
  );
}

export default Head;

const HeadSection = styled.section`
  min-height: calc(100vh - 112px - 84px);
  /* overflow-x: hidden; */
  position: relative;
  padding-bottom: 70px;

  @media screen and (max-width: 982px) {
    padding-bottom: 0;
  }

  .banner-section {
    width: 85%;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }

  @media screen and (min-width: 1200px) and (max-width: 1440px) {
    .banner-section {
      width: 90%;
    }
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section {
      width: 100%;
      padding: 0 20px;
    }
  }

  @media screen and (max-width: 982px) {
    .banner-section {
      width: 100%;
      margin-top: 0;
      padding: 0;
      flex-direction: column-reverse;
    }
  }

  .banner-section .video-wrapper {
    width: 70%;
    min-height: 600px;
    position: relative;
  }

  .banner-section .video-wrapper .progressive-image {
    position: relative;
    border-radius: 5px;
    min-height: 465px;
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .video-wrapper .progressive-image {
      min-height: unset;
    }
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper .progressive-image {
      min-height: unset;
    }
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .video-wrapper {
      min-height: 500px;
    }
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper {
      width: 100%;
      min-height: unset;
      border-radius: 0;
    }
  }

  .banner-section .video-wrapper .video-player {
    width: 100%;
    border-radius: 5px;
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper .video-player {
      border-radius: 0;
    }
  }

  .banner-section .video-wrapper .mobile {
    display: none;
    object-fit: cover;
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper .mobile {
      display: flex;
    }
  }

  .banner-section .video-wrapper .filmr-promo {
    display: none;
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper .filmr-promo {
      display: flex;
    }
  }

  .banner-section .video-wrapper .desktop {
    display: flex;
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper .desktop {
      display: none;
    }
  }

  .banner-section .video-wrapper .overlay-parent {
    position: absolute;
    top: 22%;
    right: 10%;
    width: 38%;
    height: 45%;
    bottom: auto;
  }

  .banner-section .video-wrapper .overlay-parent.mobile {
    display: none;
  }

  @media (max-width: 768px) {
    .banner-section .video-wrapper .overlay-parent.desktop {
      display: none;
    }

    .banner-section .video-wrapper .overlay-parent.mobile {
      display: block;
      top: 16%;
      left: 10%;
      width: 80%;
      bottom: 0;
    }

    .banner-section .video-wrapper .overlay-parent.mobile .title {
      text-align: center;
      font-family: Inter;
      font-size: 44px;
      font-weight: 700;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #fff;
    }

    .banner-section .video-wrapper .overlay-parent.mobile .sub-title {
      font-family: Inter;
      font-size: 18px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #fff;
      text-align: center;
      margin-bottom: 25px;
    }

    .banner-section .video-wrapper .overlay-parent.mobile .cta {
      display: flex;
      justify-content: center;
    }

    .banner-section .video-wrapper .overlay-parent.mobile .cta button {
      text-align: center;
      background: #39f;
      justify-content: center;
      color: #fff;
      padding: 15px 50px;
      border-radius: 10px;
      cursor: pointer;
      font-size: 1.0625rem;
      line-height: 1.6;
    }

    .banner-section .video-wrapper .overlay-parent.mobile .cta-sub-title {
      font-family: Inter;
      font-size: 12px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #fff;
      text-align: center;
      opacity: 0.74;
    }
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper .overlay-parent {
      top: 15%;
      left: 15%;
      width: 70%;
      height: 40%;
      bottom: 0;
    }
  }

  .banner-section .video-wrapper .overlay-parent .overlay-content {
    width: 0;
    height: 0;
    background: rgba(25, 29, 44, 0.3);
    border-radius: 3px;
  }

  .banner-section
    .video-wrapper
    .overlay-parent
    .overlay-content
    .text-content {
    position: absolute;
    top: 0;
    left: 7%;
    width: 85%;
    height: auto;
    font-size: 33px;
    line-height: 1.15;
    letter-spacing: 2px;
    color: #fff;
    padding: 18px 0 0;
    overflow: hidden;
  }

  @media screen and (max-width: 982px) {
    .banner-section
      .video-wrapper
      .overlay-parent
      .overlay-content
      .text-content {
      font-size: 6vw;
      letter-spacing: 1px;
    }
  }

  .banner-section
    .video-wrapper
    .overlay-parent
    .overlay-content
    .text-content
    p {
    margin: 0;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    animation-duration: 0.8s;
    animation-timing-function: ease-in;
    width: 0;
  }

  .banner-section
    .video-wrapper
    .overlay-parent
    .overlay-content
    .hidden-started-btn {
    max-width: 80%;
    height: 16%;
    position: absolute;
    bottom: -50%;
    right: -110%;
    cursor: pointer;
    background: #39f;
    border-radius: 3px;
    color: #fff;
    padding: 5px 10px;
    font-size: 1vw;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    z-index: 1;
    letter-spacing: 1.1px;
  }

  @media screen and (max-width: 982px) {
    .banner-section
      .video-wrapper
      .overlay-parent
      .overlay-content
      .hidden-started-btn {
      width: 85%;
      max-height: 20%;
      padding: 5px 10px;
      font-size: 2.5vw;
      min-height: 15%;
      left: -128%;
      right: auto;
    }
  }

  .banner-section
    .video-wrapper
    .overlay-parent
    .overlay-content
    .hidden-started-btn:hover {
    background: #211d70 !important;
    text-decoration: none;
  }

  .banner-section
    .video-wrapper
    .overlay-parent
    .overlay-content
    .hidden-started-btn.mobile {
    width: 36%;
    height: 15%;
    top: 65%;
    left: 32.4%;
  }

  .banner-section .video-wrapper .overlay-parent img.overlay-cursor {
    height: 22px;
    width: auto;
    position: absolute;
    top: auto;
    bottom: -50%;
    right: -100%;
    z-index: 1;
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper .overlay-parent img.overlay-cursor {
      left: -123%;
      right: auto;
    }
  }

  .banner-section .video-wrapper #main-video,
  .banner-section .video-wrapper #main-video-mobile {
    background: #8bc2e4 no-repeat center center fixed;
    min-height: 465px;
  }

  @media screen and (min-width: 982px) and (max-width: 1600px) {
    .banner-section .video-wrapper #main-video,
    .banner-section .video-wrapper #main-video-mobile {
      height: auto;
      min-height: unset;
    }
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper #main-video,
    .banner-section .video-wrapper #main-video-mobile {
      height: 600px;
      min-height: unset;
    }
  }

  .banner-section .video-wrapper .video-player.overlay {
    position: absolute;
    top: 40px;
    left: -70px;
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper .video-player.overlay {
      top: 30%;
      left: 16%;
    }
  }

  @media screen and (max-width: 982px) {
    .banner-section .video-wrapper .video-player.overlay.mobile {
      object-fit: cover;
      top: 35%;
      left: 0;
    }
  }

  .banner-section .auth-section {
    width: 30%;
    min-height: 600px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  @media (max-width: 768px) {
    .banner-section .auth-section {
      display: none;
    }
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .auth-section {
      min-height: 500px;
    }
  }

  @media screen and (max-width: 982px) {
    .banner-section .auth-section {
      width: 95%;
      min-height: unset;
      align-items: center;
      margin-top: 20px;
    }
  }

  .banner-section .auth-section .signup-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 320px;
    border-radius: 4px;
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .auth-section .signup-container {
      width: 90%;
      height: auto;
      margin: 0;
    }
  }

  @media screen and (min-width: 425px) and (max-width: 982px) {
    .banner-section .auth-section .signup-container {
      height: auto;
      margin: 0 auto;
      align-items: center;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 425px) {
    .banner-section .auth-section .signup-container {
      width: 100%;
      margin: 0 auto;
      align-items: center;
    }
  }

  .banner-section .auth-section .signup-container .signup-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    padding: 10px 0;
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .auth-section .signup-container .signup-text {
      width: 100%;
    }
  }

  .banner-section .auth-section .signup-container .signup-text h1 {
    line-height: 50px;
    font-size: 30px;
    font-weight: 700;
    color: #29227d;
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .auth-section .signup-container .signup-text h1 {
      line-height: 40px;
    }
  }

  .banner-section .auth-section .signup-container .signup-text .auth-intro {
    margin: 0;
    padding: 0;
    color: #29227d;
  }

  .banner-section .auth-section .signup-container .signup-btn {
    width: 100%;
    margin-bottom: 16px;
    min-height: 50px;
    border-radius: 4px;
    border: solid 0.5px #29227d;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    color: #29227d;
    cursor: pointer;
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .auth-section .signup-container .signup-btn {
      width: 100%;
      min-height: 42px;
    }
  }

  .banner-section .auth-section .signup-container .signup-btn .logo {
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .banner-section .auth-section .signup-container .signup-btn .logo img {
    width: 20px;
    height: 20px;
  }

  .banner-section .auth-section .signup-container .signup-btn .logo .fab {
    font-size: 20px;
  }

  .banner-section .auth-section .signup-container .btn-text {
    font-size: 15px;
    width: 70%;
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .auth-section .signup-container .btn-text {
      font-size: 12px;
    }
  }

  .banner-section .auth-section .signup-container .signup-btn.email {
    background-color: #29227d;
    color: #fff;
  }

  .banner-section
    .auth-section
    .signup-container
    .signup-btn.email
    button.signUp-btn {
    cursor: pointer;
    background: 0 0;
    border: none;
    color: #fff;
    outline: 0;
    width: 100%;
    text-align: center;
  }

  .banner-section .auth-section .signup-container .already-member {
    font-size: 15px;
    color: #29227d;
  }

  .banner-section .auth-section .signup-container .signin-text {
    margin: 10px 0 0;
  }

  .banner-section .auth-section .signup-container .signin-text .login-text {
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
  }

  .banner-section
    .auth-section
    .signup-container
    .signup-form
    .form-group.phone {
    display: flex;
    justify-content: flex-start;
  }

  .banner-section .auth-section .signup-container .signup-form .signup-input {
    background: #fff;
    border-radius: 4px;
    padding: 9px 12px 10px;
    border: 1px solid rgba(14, 19, 24, 0.2);
    cursor: text;
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    color: #29227d;
    outline: 0;
    font-size: 14px;
  }

  .banner-section
    .auth-section
    .signup-container
    .signup-form
    .signup-input:focus {
    border-color: #00c4cc;
  }

  .banner-section
    .auth-section
    .signup-container
    .signup-form
    .signup-global-error {
    padding: 10px 0;
  }

  .banner-section .auth-section .signup-container .signup-form .signup-err {
    color: #f84856;
    font-size: 14px;
  }

  .banner-section
    .auth-section
    .signup-container
    .signup-form
    select#country-code-signup {
    width: 85%;
  }

  .banner-section .auth-section .signup-container .signup-form .code {
    width: 50%;
  }

  .banner-section .auth-section .signup-container .signup-form .number {
    width: 100%;
  }

  .banner-section .auth-section .signup-container .signin-section {
    display: none;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .form-group.phone {
    display: flex;
    justify-content: flex-start;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .signup-input {
    background: #fff;
    border-radius: 4px;
    padding: 9px 12px 10px;
    border: 1px solid rgba(14, 19, 24, 0.2);
    cursor: text;
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    color: #29227d;
    outline: 0;
    font-size: 14px;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .signup-input:focus {
    border-color: #00c4cc;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .signin-global-error {
    padding: 10px 0;
  }

  .banner-section .auth-section .signup-container .signin-section .signup-err {
    color: #f84856;
    font-size: 14px;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    select#country-code-signup {
    width: 85%;
  }

  .banner-section .auth-section .signup-container .signin-section .code {
    width: 50%;
  }

  .banner-section .auth-section .signup-container .signin-section .number {
    width: 100%;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .divider-section {
    display: flex;
    align-items: center;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .divider-section
    hr {
    width: 100%;
    height: 2px;
    margin-top: 1.3rem;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .divider-section
    span {
    margin: 10px 15px;
    font-family: Inter;
    font-size: 13px;
    line-height: 2.5;
    color: #d8d1d1;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .button-client {
    padding: 10px 0;
    width: 100%;
    border-radius: 5px;
    border: 2px solid #39f;
    background: #fff;
    font-family: Inter;
    font-size: 1em;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 10px 0;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .button-client
    img {
    width: 23px;
    margin-right: 10px;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    #email-signup-btn {
    width: 100%;
    margin-bottom: 16px;
    min-height: 50px;
    border-radius: 4px;
    border: solid 0.5px #29227d;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    background: #29227d;
    cursor: pointer;
    color: #fff;
    position: relative;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    #submit-button-signin {
    cursor: pointer;
    background: 0 0;
    border: none;
    color: #fff;
    outline: 0;
    width: 100%;
    text-align: center;
    font-size: 16px;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .signin-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 10px 0;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .signin-header
    span {
    cursor: pointer;
  }

  .banner-section
    .auth-section
    .signup-container
    .signin-section
    .signin-header
    h3 {
    color: #29227d;
    font-size: 25px;
  }

  .banner-section .auth-section .info-section {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0.5;
    margin-top: 20%;
    margin-bottom: 20px;
  }

  @media screen and (min-width: 1600px) {
    .banner-section .auth-section .info-section {
      justify-content: flex-end;
      margin-top: 60px;
    }
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .auth-section .info-section {
      width: 100%;
      margin-top: 20%;
    }
  }

  @media screen and (max-width: 982px) {
    .banner-section .auth-section .info-section {
      width: 100%;
      margin-bottom: 20px;
      margin-top: 5%;
    }
  }

  .banner-section .auth-section .info-section .client {
    min-width: 85px;
    padding: 0 15px;
    position: relative;
  }

  @media screen and (min-width: 983px) and (max-width: 1200px) {
    .banner-section .auth-section .info-section .client {
      padding: 0 10px;
    }
  }

  @media screen and (max-width: 982px) {
    .banner-section .auth-section .info-section .client {
      margin: 0;
    }
  }

  .banner-section .auth-section .info-section .client picture img {
    height: 18px;
  }

  .banner-section .auth-section .info-section .client span.company-stars {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .banner-section .auth-section .info-section .client span.company-stars img {
    margin-top: 5px;
    width: 60px;
    height: unset;
  }

  .banner-section .auth-section .info-section .client:after {
    content: '';
    position: absolute;
    right: 0;
    width: 1px;
    height: 15px;
    background: #2162a3;
    top: 30%;
  }

  .banner-section .auth-section .info-section .client:first-of-type {
    padding-left: 0;
  }

  .banner-section .auth-section .info-section .score-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    min-height: 40px;
    padding: 0 15px;
  }

  @media screen and (max-width: 1200px) {
    .banner-section .auth-section .info-section .score-wrapper {
      padding: 0 10px;
    }
  }

  .banner-section .auth-section .info-section .score-wrapper .label {
    font-size: 10px;
    margin-bottom: 0;
  }

  @media screen and (max-width: 982px) {
    .banner-section .auth-section .info-section .score-wrapper .label {
      font-size: 8px;
    }
  }

  .banner-section .auth-section .info-section .score-wrapper picture img {
    width: 16px;
  }

  .banner-section .auth-section .info-section .score-wrapper .counter-wrapper {
    margin-top: 8px;
  }

  .banner-section
    .auth-section
    .info-section
    .score-wrapper
    .counter-wrapper
    .value {
    font-size: 15px;
    line-height: normal;
    letter-spacing: 2px;
    color: #29227d;
    font-weight: 600;
  }
`;
